import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=be3b5100&scoped=true&"
import script from "./AccountActivation.vue?vue&type=script&lang=js&"
export * from "./AccountActivation.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivation.vue?vue&type=style&index=0&id=be3b5100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3b5100",
  null
  
)

export default component.exports